var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"mediacontact-region-create","title":"Region erstellen","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('mediacontact-region-form',{attrs:{"mediacontactRegion":_vm.mediacontactRegion,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }